// import { CropFree, ZoomInMap } from "@mui/icons-material";
// import { Avatar, Grid, IconButton, Typography } from "@mui/material";
// import React, { useEffect, useRef, useState } from "react";
// import { useStyle } from "../style";
// import moment from "moment";
// import StockverificationBillingTable from "./stockverificationbarcodeTable";
// import Logo from "../../../../../assets/images/Girlush Logo.png"
// import { useNavigate } from "react-router-dom";
// import { Helmet } from "react-helmet-async";
// import Stockverificationcustomerinfo from "./stockverificationcustomerinfo";
// import Grid2 from "@mui/material/Unstable_Grid2";
// function StockVerifiactionBarcode(){
//      const classes = useStyle();
//       const fullscreenRef = useRef(null);
//       const codeRef = useRef(null)
//       const [isFull, setIsFull] = useState(false);
//       const [data, setData] = useState([])
//       const[verifyEnable , setVerifyEnable] = useState('')
//       const navigate = useNavigate()

//       const toggleFullscreen = () => {
//         const isFullScreen = document.fullscreenElement
//         if(isFullScreen){
//           document.exitFullscreen()
//           setIsFull(!isFull)
//         }
//         else{
//           fullscreenRef.current.requestFullscreen();
//           setIsFull(!isFull)
//         }
//       };

//       useEffect(() => {
//         const checkFullscreen = () => {
//           const isFullScreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
//           setIsFull(!!isFullScreen);
//         };

//         const handleEscapeKey = (event) => {
//           if (event.key === 'Escape') {
//             checkFullscreen();
//           }
//         };

//         document.addEventListener('fullscreenchange', checkFullscreen);
//         document.addEventListener('mozfullscreenchange', checkFullscreen);
//         document.addEventListener('webkitfullscreenchange', checkFullscreen);
//         document.addEventListener('msfullscreenchange', checkFullscreen);
//         document.addEventListener('keydown', handleEscapeKey);

//         return () => {
//           document.removeEventListener('fullscreenchange', checkFullscreen);
//           document.removeEventListener('mozfullscreenchange', checkFullscreen);
//           document.removeEventListener('webkitfullscreenchange', checkFullscreen);
//           document.removeEventListener('msfullscreenchange', checkFullscreen);
//           document.removeEventListener('keydown', handleEscapeKey);
//         };
//       }, [setIsFull]);
//     console.log(verifyEnable)
//     return(
//           <Grid ref={fullscreenRef} className={classes.root}>
//               <Helmet>
//                 <title>Stock Verification Barcode</title>
//               </Helmet>
//               <Grid className={classes.titleInfo} sx={{paddingBlock:"25px"}}>
//                 {/* {isFull ? <IconButton onClick={toggleFullscreen}><ZoomInMap /></IconButton>
//                  : <IconButton onClick={toggleFullscreen}><CropFree /></IconButton>} */}
//                 <Grid className="flex justify-between items-center">
//                   {/* <Avatar variant="square" src={Logo}
//                   onClick={() => navigate('/dashboard')} sx={{cursor:"pointer",}}/> */}
//                   <Avatar variant="square" src={Logo} onClick={() => navigate('/dashboard')} sx={{ cursor: "pointer",zIndex: 9999,position: "relative",pointerEvents: "auto" }}/>

//                   <Typography  fontWeight={600} ml={1} onClick={() => navigate('/dashboard')} sx={{cursor:"pointer",fontSize:20}}>GIRLUSH</Typography>
//                 </Grid>
//                 <Typography variant="h5" fontWeight={600}>Stock Verification Barcode </Typography>
//                 <Typography onClick={()=>toggleFullscreen()}>Press F11 to Full Screen </Typography>
//               </Grid>
//               <Grid2></Grid2>
//               <Grid
//               className={classes.contentGrid}
//               >
//                 <Grid className="w-5/6" sx={{display: 'flex', flexDirection:'column',  flex: 1,height: "calc(100% - 40px)",}}>
//                   <Grid className="p-2 " sx={{flex:1,}}><StockverificationBillingTable  forwardRef={codeRef} setVerifyEnable={setVerifyEnable} verifyEnable={verifyEnable}/></Grid>
//                 </Grid>
//                 <Grid className="w-1/6 h-full border-l py-2">
//                   <Grid className="border-b px-3">
//                      <Stockverificationcustomerinfo   verifyEnable={verifyEnable} />
//                   </Grid>

//                 </Grid>
//               </Grid>
//             </Grid>

//     )
// }
// export default StockVerifiactionBarcode

// import { CropFree, ZoomInMap } from "@mui/icons-material";
// import { Avatar, Grid, IconButton, Typography } from "@mui/material";
// import React, { useEffect, useRef, useState } from "react";
// import { useStyle } from "../style";
// import moment from "moment";
// import StockverificationBillingTable from "./stockverificationbarcodeTable";
// import Logo from "../../../../../assets/images/Girlush Logo.png";
// import { useNavigate } from "react-router-dom";
// import { Helmet } from "react-helmet-async";
// import StockVerificationCustomerInfo from "./stockverificationcustomerinfo";
// import Grid2 from "@mui/material/Unstable_Grid2";

// function StockVerifiactionBarcode() {
//   const classes = useStyle();
//   const fullscreenRef = useRef(null);
//   const [isFull, setIsFull] = useState(false);

//   // scanned temp list (comes from backend /stock-verify/temp/:outlet_id)
//   const [tempList, setTempList] = useState([]);

//   // current bill number selected for SAVE
//   const [verifyEnable, setVerifyEnable] = useState("");

//   // current barcode input value
//   const [barcode, setBarcode] = useState("");

//   const navigate = useNavigate();

//   // outlet & company from storage (or wherever you store them)
//   const outletId =
//     Number(localStorage.getItem("OUTLET_ID")) ||
//     Number(sessionStorage.getItem("OUTLET_ID")) ||
//     0;

//   const companyId =
//     Number(localStorage.getItem("COMPANY_ID")) ||
//     Number(sessionStorage.getItem("COMPANY_ID")) ||
//     0;

//   const toggleFullscreen = () => {
//     const isFullScreen = document.fullscreenElement;
//     if (isFullScreen) {
//       document.exitFullscreen();
//       setIsFull(false);
//     } else if (fullscreenRef.current) {
//       fullscreenRef.current.requestFullscreen();
//       setIsFull(true);
//     }
//   };

//   useEffect(() => {
//     const checkFullscreen = () => {
//       const isFullScreen =
//         document.fullscreenElement ||
//         document.mozFullScreenElement ||
//         document.webkitFullscreenElement ||
//         document.msFullscreenElement;
//       setIsFull(!!isFullScreen);
//     };

//     const handleEscapeKey = (event) => {
//       if (event.key === "Escape") {
//         checkFullscreen();
//       }
//     };

//     document.addEventListener("fullscreenchange", checkFullscreen);
//     document.addEventListener("mozfullscreenchange", checkFullscreen);
//     document.addEventListener("webkitfullscreenchange", checkFullscreen);
//     document.addEventListener("msfullscreenchange", checkFullscreen);
//     document.addEventListener("keydown", handleEscapeKey);

//     return () => {
//       document.removeEventListener("fullscreenchange", checkFullscreen);
//       document.removeEventListener("mozfullscreenchange", checkFullscreen);
//       document.removeEventListener("webkitfullscreenchange", checkFullscreen);
//       document.removeEventListener("msfullscreenchange", checkFullscreen);
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   return (
//     <Grid ref={fullscreenRef} className={classes.root}>
//       <Helmet>
//         <title>Stock Verification Barcode</title>
//       </Helmet>

//       <Grid className={classes.titleInfo} sx={{ paddingBlock: "25px" }}>
//         <Grid className="flex justify-between items-center">
//           <Avatar
//             variant="square"
//             src={Logo}
//             onClick={() => navigate("/dashboard")}
//             sx={{
//               cursor: "pointer",
//               zIndex: 9999,
//               position: "relative",
//               pointerEvents: "auto",
//             }}
//           />
//           <Typography
//             fontWeight={600}
//             ml={1}
//             onClick={() => navigate("/dashboard")}
//             sx={{ cursor: "pointer", fontSize: 20 }}
//           >
//             GIRLUSH
//           </Typography>
//         </Grid>
//         <Typography variant="h5" fontWeight={600}>
//           Stock Verification Barcode
//         </Typography>
//         <Typography onClick={toggleFullscreen}>
//           Press F11 to Full Screen
//         </Typography>
//       </Grid>

//       <Grid2>{/* reserved grid if you want filters/date later */}</Grid2>

//       <Grid className={classes.contentGrid}>
//         {/* LEFT: barcode + table */}
//         <Grid
//           className="w-5/6"
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             flex: 1,
//             height: "calc(100% - 40px)",
//           }}
//         >
//           <Grid className="p-2" sx={{ flex: 1 }}>
//             <StockverificationBillingTable
//               barcode={barcode}
//               setBarcode={setBarcode}
//               tempList={tempList}
//               setTempList={setTempList}
//               outletId={outletId}
//               companyId={companyId}
//             />
//           </Grid>
//         </Grid>

//         {/* RIGHT: bill no + Save / Exit */}
//         <Grid className="w-1/6 h-full border-l py-2" sx={{ position: "relative" }}>
//           <Grid className="border-b px-3" sx={{ height: "100%", position: "relative" }}>
//             <StockVerificationCustomerInfo
//               verifyEnable={verifyEnable}
//               setVerifyEnable={setVerifyEnable}
//               outletId={outletId}
//               setTempList={setTempList}
//             />
//           </Grid>
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// }

// export default StockVerifiactionBarcode;

// new

// StockVerifiactionBarcode.js
// import { CropFree, ZoomInMap } from "@mui/icons-material";
// import { Avatar, Grid, IconButton, Typography } from "@mui/material";
// import React, { useEffect, useRef, useState } from "react";
// import { useStyle } from "../style";
// import moment from "moment";
// import StockverificationBillingTable from "./stockverificationbarcodeTable";
// import Logo from "../../../../../assets/images/Girlush Logo.png";
// import { useNavigate } from "react-router-dom";
// import { Helmet } from "react-helmet-async";
// import StockVerificationCustomerInfo from "./stockverificationcustomerinfo";
// import Grid2 from "@mui/material/Unstable_Grid2";
// import axios from "axios";

// function StockVerifiactionBarcode() {
//   const classes = useStyle();
//   const fullscreenRef = useRef(null);
//   const navigate = useNavigate();

//   const [data, setData] = useState([]);
//   const [verifyEnable, setVerifyEnable] = useState("");

//   const outletId = localStorage.getItem("outlet_id");

//   // LOAD TEMP DATA
//   const loadTempData = async () => {
//     try {
//       const res = await axios.get(`/v1/stock_verify/temp/${outletId}`);
//       setData(res.data);
//     } catch (err) {
//       console.error("Error loading temp:", err);
//     }
//   };

//   // INITIAL LOAD
//   useEffect(() => {
//     loadTempData();
//   }, []);

//   return (
//     <Grid ref={fullscreenRef} className={classes.root}>
//       <Helmet>
//         <title>Stock Verification Barcode</title>
//       </Helmet>

//       <Grid className={classes.titleInfo} sx={{ paddingBlock: "25px" }}>
//         <Grid className="flex justify-between items-center">
//           <Avatar
//             variant="square"
//             src={Logo}
//             sx={{ cursor: "pointer", zIndex: 9999 }}
//             onClick={() => navigate("/dashboard")}
//           />
//           <Typography fontWeight={600} ml={1} sx={{ cursor: "pointer", fontSize: 20 }}>
//             GIRLUSH
//           </Typography>
//         </Grid>
//         <Typography variant="h5" fontWeight={600}>Stock Verification Barcode</Typography>
//         <Typography>Press F11 to Full Screen</Typography>
//       </Grid>

//       <Grid2 />

//       <Grid className={classes.contentGrid}>
//         {/* Billing Table */}
//         <Grid className="w-5/6">
//           <StockverificationBillingTable
//             data={data}
//             loadTempData={loadTempData}
//             verifyEnable={verifyEnable}
//             setVerifyEnable={setVerifyEnable}
//           />
//         </Grid>

//         {/* Sidebar - Customer Info */}
//         <Grid className="w-1/6 border-l py-2">
//           <StockVerificationCustomerInfo
//             data={data}
//             loadTempData={loadTempData}
//             verifyEnable={verifyEnable}
//           />
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// }

// export default StockVerifiactionBarcode;

import { CropFree, ZoomInMap } from "@mui/icons-material";
import { Avatar, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useStyle } from "../style";
import moment from "moment";
import StockverificationBillingTable from "./stockverificationbarcodeTable";
import Logo from "../../../../../assets/images/Girlush Logo.png";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import StockVerificationCustomerInfo from "./stockverificationcustomerinfo";
import Grid2 from "@mui/material/Unstable_Grid2";
import axios from "axios";

function StockVerifiactionBarcode() {
  const classes = useStyle();
  const fullscreenRef = useRef(null);
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const hasData = data && data.length > 0;
  const [verifyEnable, setVerifyEnable] = useState("");

  const outletId = localStorage.getItem("outlet_id");

  // LOAD TEMP DATA
  const loadTempData = async () => {
    try {
      const res = await axios.get(`/v1/stock_verify/temp/${outletId}`);
      setData(res.data);
    } catch (err) {
      console.error("Error loading temp:", err);
    }
  };

  // INITIAL LOAD
  useEffect(() => {
    loadTempData();
  }, []);

  return (
    <Grid ref={fullscreenRef} className={classes.root}>
      <Helmet>
        <title>Stock Verification Barcode</title>
      </Helmet>

      <Grid className={classes.titleInfo} sx={{ paddingBlock: "25px" }}>
        <Grid className="flex justify-between items-center">
          <Avatar
            variant="square"
            src={Logo}
            sx={{ cursor: "pointer", zIndex: 9999 }}
            onClick={() => navigate("/dashboard")}
          />
          <Typography
            fontWeight={600}
            ml={1}
            sx={{ cursor: "pointer", fontSize: 20 }}
          >
            GIRLUSH
          </Typography>
        </Grid>
        <Typography variant="h5" fontWeight={600}>
          Stock Verification Barcode
        </Typography>
        <Typography>Press F11 to Full Screen</Typography>
      </Grid>

      <Grid2 />

      <Grid className={classes.contentGrid}>
        {/* Billing Table */}
        <Grid className="w-5/6">
          <StockverificationBillingTable
            data={data}
            loadTempData={loadTempData}
            verifyEnable={verifyEnable}
            setVerifyEnable={setVerifyEnable}
          />
        </Grid>

        {/* Sidebar - Customer Info */}
        {/* <Grid className="w-1/6 border-l py-2"> */}
        <Grid
          className="w-1/6 border-l"
          sx={{
            backgroundColor: "#ffffff",
            boxShadow: "inset 1px 0 0 rgba(0,0,0,0.05)",
          }}
        >
          <StockVerificationCustomerInfo
            data={data}
            loadTempData={loadTempData}
            verifyEnable={verifyEnable}
             hasData={hasData}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default StockVerifiactionBarcode;
